export default "__VITE_ASSET__LQ6c0l5O__"